module.exports = __webpack_public_path__ + "img/borderAngleBracesWhite.dfdb20a9.svg";